// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { getDateInformation } from '@tcp/core/src//utils/badge.util';
import {
  convertToISOString,
  getFormatedOrderDate,
  getFormatedOrderTime,
  getDateObject,
} from '@tcp/core/src/utils/utils';
import {
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  ACCOUNT_ORDERS_LABEL,
  OrderDetailLabels,
  lblBossStatus,
  lblExpectedPickup,
  lblExpirationDate,
  lblOrdersAt,
  lvlOrderDate,
} from '../../../container/OrderDetails.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblOrderNumber,
} from '../../../../../../../utils/labels/globalGeneric.labels';

/**
 * This function component use for return the OrderBasicDetails
 * can be passed in the component.
 * @param orderDetailsData - orderDetailsData object used for showing Order Details
 */

const OrderBasicDetails = ({ className, orderDetailsData }) => {
  const { orderNumber, isBossOrder, status } = orderDetailsData;
  const { orderDate, pickUpExpirationDate } = orderDetailsData;
  let { bossMaxDate, bossMinDate } = orderDetailsData;
  const orderDateParsed = getDateObject(convertToISOString(orderDate));
  const pickUpExpirationDateParsed = getDateObject(convertToISOString(pickUpExpirationDate));
  bossMinDate = getDateInformation(bossMinDate);
  bossMaxDate = getDateInformation(bossMaxDate);
  const bossDate =
    !!(bossMinDate && bossMaxDate) &&
    `${bossMinDate.day}. ${bossMinDate.month} ${bossMinDate.date} - ${bossMaxDate.day}. ${bossMaxDate.month} ${bossMaxDate.date}`;

  const orderLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_ORDERS_LABEL, OrderDetailLabels);
  /**
   * @function return  render the JSX of BOSS order pickup details
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */
  const getExpectedPickupDetails = () => {
    if (isBossOrder && bossDate) {
      return (
        <BodyCopy component="div" className="elem-mt-LRG">
          <BodyCopy
            fontSize="fs14"
            fontWeight="extrabold"
            fontFamily="secondary"
            className="elem-mb-SM"
          >
            {getLabelWithDefaultValue(orderLabels, lblExpectedPickup)}
          </BodyCopy>
          <BodyCopy fontSize="fs14" fontFamily="secondary">
            {bossDate}
          </BodyCopy>
          {status?.toLowerCase() !== 'completed' && (
            <div>
              <BodyCopy
                fontSize="fs14"
                fontWeight="extrabold"
                fontFamily="secondary"
                className="elem-mb-SM elem-mt-MED"
              >
                {getLabelWithDefaultValue(orderLabels, lblBossStatus)}
              </BodyCopy>
              <BodyCopy
                fontSize="fs14"
                fontFamily="secondary"
                fontWeight="black"
                className="elem-mb-SM"
              >
                {status}
              </BodyCopy>
            </div>
          )}
        </BodyCopy>
      );
    }
    return <></>;
  };
  /**
   * @function return  Used to render the JSX of the component
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */
  return (
    <div className={className}>
      <BodyCopy component="div">
        <BodyCopy
          fontSize="fs14"
          fontWeight="extrabold"
          fontFamily="secondary"
          className="elem-mb-SM"
        >
          {getLabelFromCopyOrFromTranslation(
            `${GLOBAL_GENERIC_LABELS}.${lblOrderNumber}`,
            GlobalGenericLabels
          )}
        </BodyCopy>
        <BodyCopy fontSize="fs14" fontWeight="black" fontFamily="secondary">
          {orderNumber}
        </BodyCopy>
      </BodyCopy>
      <BodyCopy component="div" className="elem-mt-LRG">
        <BodyCopy
          fontSize="fs14"
          fontWeight="extrabold"
          fontFamily="secondary"
          className="elem-mb-SM"
        >
          {getLabelWithDefaultValue(orderLabels, lvlOrderDate)}
        </BodyCopy>
        {orderDate ? (
          <BodyCopy fontSize="fs14" fontFamily="secondary">
            {getFormatedOrderDate(orderDateParsed)}
            {
              <>
                <BodyCopy
                  component="span"
                  fontSize="fs14"
                  className="elem-mr-XXS elem-ml-XXS"
                  fontFamily="secondary"
                >
                  {getLabelWithDefaultValue(orderLabels, lblOrdersAt)}
                </BodyCopy>
                <BodyCopy component="span" fontSize="fs14" fontFamily="secondary">
                  {getFormatedOrderTime(orderDateParsed)}
                </BodyCopy>
              </>
            }
          </BodyCopy>
        ) : null}
      </BodyCopy>
      {!!pickUpExpirationDate && !isBossOrder && (
        <BodyCopy component="div" className="elem-mt-LRG">
          <BodyCopy
            fontSize="fs14"
            fontWeight="extrabold"
            fontFamily="secondary"
            className="elem-mb-SM"
          >
            {getLabelWithDefaultValue(orderLabels, lblExpirationDate)}
          </BodyCopy>
          <BodyCopy fontSize="fs14" fontFamily="secondary">
            {getFormatedOrderDate(pickUpExpirationDateParsed)}
            <BodyCopy
              component="span"
              fontSize="fs14"
              className="elem-mr-XXS elem-ml-XXS"
              fontFamily="secondary"
            >
              {getLabelWithDefaultValue(orderLabels, lblOrdersAt)}
            </BodyCopy>
            <BodyCopy component="span" fontSize="fs14" fontFamily="secondary">
              {getFormatedOrderTime(pickUpExpirationDateParsed)}
            </BodyCopy>
          </BodyCopy>
        </BodyCopy>
      )}
      {getExpectedPickupDetails()}
    </div>
  );
};
OrderBasicDetails.propTypes = {
  className: PropTypes.string,
  orderDetailsData: PropTypes.shape({}),
};

OrderBasicDetails.defaultProps = {
  className: '',
  orderDetailsData: {},
};

export default OrderBasicDetails;
